<lang-change></lang-change>
<div class="container login-container">
    <div class="card card-container">
        <p id="profile-name" class="profile-name-card"> Account Approval Page </p>
    <form name="form" (ngSubmit)="f.form.valid && approve()" #f="ngForm" novalidate>

        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
            <label for="username" i18n>Username</label>
            <input type="text" class="form-control" name="username" [(ngModel)]="model.username" #username="ngModel" id="username"/>
            <div *ngIf="f.submitted && !username.valid" class="help-block" i18n>Username is required</div>
        </div>

        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
            <label for="first_name" i18n>First Name</label>
            <input type="text" class="form-control" name="first_name" [(ngModel)]="model.first_name" #first_name="ngModel" value= "model.first_name" id="first_name" />
            <div *ngIf="f.submitted && !first_name.valid" class="help-block" i18n>First Name is required</div>
        </div>

        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
            <label for="last_name" i18n>Last Name</label>
            <input type="text" class="form-control" name="last_name" [(ngModel)]="model.last_name" #last_name="ngModel" id="last_name"/>
            <div *ngIf="f.submitted && !last_name.valid" class="help-block" i18n>Last Name is required</div>
        </div>

        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
            <label for="email" i18n>Email</label>
            <input type="text" class="form-control" name="email" [(ngModel)]="model.email" #email="ngModel" required id="email"/>
            <div *ngIf="f.submitted && !email.valid" class="help-block" i18n>Email is required</div>
        </div>
<!--
        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !country.valid }">
            <label for="country" i18n>Country</label>
            <input type="text" class="form-control" name="country" [(ngModel)]="model.country" #country="ngModel" required id="country"/>
            <div *ngIf="f.submitted && !country.valid" class="help-block" i18n>Country is required</div>
        </div> -->

<!--        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !userteam.valid }" *ngIf="teams$ | async as teams">
            <label for="userteam" i18n>Country</label>
            <select [(ngModel)]="model.team" class="form-control" id="userteam" name="first" #userteam="ngModel">
                <option [ngValue]="undefined" selected="true" i18n>Select a team</option>
                <option *ngFor="let team of teamlist" [value]="team.id">{{team.name}}</option>
            </select>
            <div *ngIf="f.submitted && !userteam.valid" class="help-block" i18n>Please select a team</div>
        </div>-->

        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !organization.valid }">
            <label for="organization" i18n>Organization</label>
            <input type="text" class="form-control" name="organization" [(ngModel)]="model.organization" #organization="ngModel" required id="organization"/>
            <div *ngIf="f.submitted && !organization.valid" class="help-block" i18n>organization is required</div>
        </div>

<!--

        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !userrole.valid }">
            <label for="userrole" i18n>Role</label>
            <select [(ngModel)]="model.role" id="userrole" class="form-control" name="first" #userrole="ngModel">
                <option [ngValue]="undefined" selected i18n>Select a role</option>
                <option *ngFor="let role of rolelist" [value]="role.id">{{role.name}}</option>
            </select>
            <div *ngIf="f.submitted && !userrole.valid" class="help-block" i18n>Please select a role</div>
        </div>

-->

        <div class="form-group">
            <button  class="btn btn-primary btn-radius btn-block" i18n>Approve</button>
            <a [routerLink]="['/home']" class="btn btn-default btn-block btn-radius" i18n>Delete</a>
        </div>
    </form>
</div><!-- /card-container -->
</div><!-- /container -->




// WEBPACK FOOTER //
// ./src/app/user-approval/user-approval.component.html